const navbar = {
  logOut: "Log Out",
  dashboard: "Home",
  screenfull: "Screenfull",
  task: "Monitor orders",
  theme: "Theme",
  size: "Global Size"
} 
export default navbar